import { IHasIsRecent } from 'helpers/addRecent';
import sortByDisplayName from 'helpers/sortByDisplayName';

/**
 * This hook returns a callback that sorts all items in a list that are part of the given recent filters
 * to the top of the array.
 */
const sortByRecent = (filterA: IHasIsRecent, filterB: IHasIsRecent): number => {
  if (filterA.isRecent && !filterB.isRecent) {
    return -1;
  }
  if (!filterA.isRecent && filterB.isRecent) {
    return 1;
  }
  if (filterA.isRecent && filterB.isRecent) {
    return 0;
  }
  return sortByDisplayName(filterA as any, filterB as any);
};

export default sortByRecent;
